import React, { useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { green_icon, red_icon, user } from "../assets/imgs";
import moment from "moment/moment";
import CommonImagePopup from "./CommonImagePopup";

const CompanyGroupView = ({ groupUsers }) => {
  const groupCat = {};
  const [open, setOpen] = useState();

  console.log("groupUsers", groupUsers);

  for (let i of groupUsers) {
    let key = i.group_category;
    if (!groupCat[key]) {
      groupCat[key] = [];
    }
    groupCat[key].push(i);
  }
  return (
    <div className="row d-flex flex-wrap align-items-start justify-content-between">
      <div className="col-md-4">
        {groupCat?.[3]?.length > 0 && (
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
            Group-1 ({groupCat?.[3]?.length})
          </p>
        )}
        <div className="w-100 ">
          {groupCat?.[3]?.map((item, ind) => {
            return (
              <div
                key={ind}
                className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary shadow p-3 mb-5 bg-body-tertiary rounded"
              >
                <div className="d-flex ac-jb">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Name
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.name}
                    />
                  </div>
                  <img
                    src={
                      item?.profile_image?.name
                        ? URL.createObjectURL(item.profile_image)
                        : item?.profile_image
                          ? item.profile_image
                          : user
                    }
                    alt=""
                    className="user mb-1 pointer"
                    style={{
                      height: "70px",
                      width: "70px",
                      borderRadius: "35px",
                    }}
                    onClick={() => setOpen(item.profile_image)}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={item?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {item?.is_email_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.phone}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Created On
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={
                      item?.created_at
                        ? moment(item?.created_at).format("DD-MM-YYYY")
                        : ""
                    }
                  />
                </div>

                <div className="d-flex ac-jb gap-3">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Alert Notifications
                    </p>
                    {item?.notification_alert ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Beep Sound
                    </p>
                    {item?.beep_sound ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="col-md-4">
        {groupCat?.[4]?.length > 0 && (
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
            Group-2 ({groupCat?.[4]?.length})
          </p>
        )}
        <div className="w-100 ">
          {groupCat?.[4]?.map((item, ind) => {
            return (
              <div
                key={ind}
                className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary shadow p-3 mb-5 bg-body-tertiary rounded"
              >
                <div className="d-flex ac-jb">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Name
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.name}
                    />
                  </div>
                  <img
                    src={
                      item?.profile_image?.name
                        ? URL.createObjectURL(item.profile_image)
                        : item?.profile_image
                          ? item.profile_image
                          : user
                    }
                    alt=""
                    className="user mb-1 pointer"
                    style={{
                      height: "70px",
                      width: "70px",
                      borderRadius: "35px",
                    }}
                    onClick={() => setOpen(item.profile_image)}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={item?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {item?.is_email_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.phone}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Created On
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={
                      item?.created_at
                        ? moment(item?.created_at).format("DD-MM-YYYY")
                        : ""
                    }
                  />
                </div>

                <div className="d-flex ac-jb gap-3">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Alert Notifications
                    </p>
                    {item?.notification_alert ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Beep Sound
                    </p>
                    {item?.beep_sound ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="col-md-4">
        {groupCat?.[5]?.length > 0 && (
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 my-3 black d-flex ac-jc">
            Group-3 ({groupCat?.[5]?.length})
          </p>
        )}
        <div className="w-100 ">
          {groupCat?.[5]?.map((item, ind) => {
            return (
              <div
                key={ind}
                className="my-5 d-flex flex-column gap-3 border border-2 p-5 primary shadow p-3 mb-5 bg-body-tertiary rounded"
              >
                <div className="d-flex ac-jb">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Name
                    </p>
                    <input
                      className="input-box w-100"
                      readOnly
                      value={item?.name}
                    />
                  </div>
                  <img
                    src={
                      item?.profile_image?.name
                        ? URL.createObjectURL(item.profile_image)
                        : item?.profile_image
                          ? item.profile_image
                          : user
                    }
                    alt=""
                    className="user mb-1 pointer"
                    style={{
                      height: "70px",
                      width: "70px",
                      borderRadius: "35px",
                    }}
                    onClick={() => setOpen(item.profile_image)}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={item?.is_email_verified ? green_icon : red_icon}
                      className="redImg"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {item?.is_email_verified ? "Verified" : "Not Verified"}
                    </p>
                  </div>
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={item?.phone}
                  />
                </div>

                <div>
                  <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Created On
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={
                      item?.created_at
                        ? moment(item?.created_at).format("DD-MM-YYYY")
                        : ""
                    }
                  />
                </div>

                <div className="d-flex ac-jb gap-3">
                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Alert Notifications
                    </p>
                    {item?.notification_alert ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>

                  <div>
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      Beep Sound
                    </p>
                    {item?.beep_sound ? (
                      <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                    ) : (
                      <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {open && <CommonImagePopup img={open} setOpen={setOpen} />}
      </div>
    </div>
  );
};

export default CompanyGroupView;
